import * as React from 'react';
import clsx from 'clsx';
import { getUrlParameter } from '../../utilities/UrlHelper';
import { makeStyles, Typography } from '@material-ui/core';
import { useHistory } from 'react-router';

const useStyles = makeStyles({
    container: {
        marginLeft: 'auto',
        marginRight: 'auto',
        textAlign: 'center',
    },
    root: {
        display: 'flex',
        marginTop: '30px',
    },
    qrImage: {
        marginTop: '30px',
        border: '1px solid #000000',
    },
    imageLarge: {
        width: '300px',
        height: '300px',
    },
});

const DemoQR = ()  => {
    let history = useHistory();
    const classes = useStyles();
    const [demoLinkId, setDemoLinkId] = React.useState<number | null>(null);

    React.useEffect(() => {
        setDemoLinkId(parseInt(getUrlParameter(history.location.search, 'i')));   
        
    }, []);

    return (
        <div className={classes.root}>
            <div className={classes.container}>

                <Typography variant="h6">
                    <div>Scan the QR Code below with your mobile device</div>
                    <div>to demo the CheckPlease payment experience</div>           
                </Typography>

                {demoLinkId !== null && 
                    <img className={clsx(classes.qrImage, classes.imageLarge)} 
                        src={process.env.REACT_APP_DEMO_QR_URL + "/" + demoLinkId.toString() + "_1.png"} />
                }

            </div>
        </div>
    );
}

export default DemoQR;